export default "__VITE_ASSET__dd80ce4f__"